import { HttpOnlySecurityService, createNavigationServiceInstance } from '@ipc/iam';
import { UserInformationProvider, useUser } from '@ipc/iam-react';

const authenticationUrl = import.meta.env.VITE_AUTHENTICATION_URL;
export const frontEndUrl = import.meta.env.VITE_FRONT_END_URL;

const adfsLoginUrl = `${authenticationUrl}/auth/login`;
const adfsLogoutUrl = `${authenticationUrl}/auth/logout`;
const refreshUrl = `${authenticationUrl}/auth/refresh`;
const failedUrl = `${frontEndUrl}/login-failed`;
const successUrl = `${frontEndUrl}/`;

const securityService = HttpOnlySecurityService.getInstance({
  cookieName: 'ipciam_expiresAt',
  navigationService: createNavigationServiceInstance({
    adfsLoginUrl,
    adfsLogoutUrl,
    failed_url: failedUrl,
  }),
  refresh_url: refreshUrl,
});

if (!securityService) {
  throw new Error('Failed to initialize security service');
}

// Create a proxy that preserves all original methods but overrides login and logout
export const httpOnlySecurityService = new Proxy(securityService, {
  get(target: HttpOnlySecurityService, prop: string | symbol) {
    if (prop === 'login') {
      return (afterLoginUrl?: string) => {
        const successRedirectUrl = afterLoginUrl || successUrl;
        const failedRedirectUrl = failedUrl;
        
        const encodedSuccessUrl = encodeURIComponent(successRedirectUrl);
        const encodedFailedUrl = encodeURIComponent(failedRedirectUrl);

        window.location.href = `${authenticationUrl}/auth/login?success_url=${encodedSuccessUrl}&failed_url=${encodedFailedUrl}`;
      };
    }
    if (prop === 'logout') {
      return () => {
        const returnUrl = encodeURIComponent(`${frontEndUrl}/`);
        window.location.href = `${authenticationUrl}/auth/logout?success_url=${returnUrl}`;
      };
    }
    return target[prop as keyof HttpOnlySecurityService];
  },
});

export { UserInformationProvider, useUser };
